import { apiClient } from '../api/apiClient';

export interface SendDietPlanResponse {
  message_id: number;
  conversation_id: number;
  provider_message_id?: string;
  status: string;
}

/**
 * Send the current meal plan PDF to the patient via WhatsApp using the registered diet plan template.
 * Requires TWILIO_WHATSAPP_TEMPLATE_DIET_PLAN_CONTENT_SID and patient WhatsApp opt-in.
 */
export async function sendDietPlanViaWhatsApp(
  planId: string,
  versionId: string
): Promise<SendDietPlanResponse> {
  const res = await apiClient.post<SendDietPlanResponse>('/api/v1/messaging/send-diet-plan', {
    plan_id: planId,
    version_id: versionId,
  });
  return res.data;
}
